import React from 'react';
import {
    Card, CardContent, Collapse, withStyles, CardHeader, IconButton
} from '@material-ui/core';
import { faAngleDown, faAngleUp } from '@fortawesome/pro-solid-svg-icons';
import clsx from 'clsx';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const styles = theme => ({
    cardHeader: {
        borderBottom: '1px solid #e6edf5',
    },
    title: {
        fontSize: 16,
        padding: '10px',
        width: '100%',
        display: 'inline-flex',
        fontWeight: 700,
    },
    cards: {
        overflow: 'visible',
    },
});

class CollapsableCard extends React.Component {
    render() {
        let { classes, title, children, avatar = null, expanded, handleCollapse = () => { } } = this.props;
        return (
            <Card className={classes.cards}>
                <CardHeader
                    disableTypography
                    className={clsx(classes.cardHeader, classes.title)}
                    color="textSecondary"
                    title={title}
                    action={
                        <IconButton onClick={() => handleCollapse()}>
                            <FontAwesomeIcon icon={expanded ? faAngleUp : faAngleDown} />
                        </IconButton>
                    }
                    avatar={avatar}
                />
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <CardContent>
                        {children}
                    </CardContent>
                </Collapse>
            </Card>
        )
    }
}

export default withStyles(styles)(CollapsableCard);
